import { render, staticRenderFns } from "./buttongroup-item.vue?vue&type=template&id=75f4a458&scoped=true&"
import script from "./buttongroup-item.vue?vue&type=script&lang=js&"
export * from "./buttongroup-item.vue?vue&type=script&lang=js&"
import style0 from "./buttongroup-item.vue?vue&type=style&index=0&id=75f4a458&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f4a458",
  null
  
)

export default component.exports